import React from 'react';

export const ToggleButton: React.FC<{
    value: boolean;
    label?: string;
    onChange?: (value: boolean) => void;
}> = ({ value, label, onChange }) => {
    const [enabled, setEnabled] = React.useState(value);

    React.useEffect(() => {
        setEnabled(value);
    }, [value]);

    const changeToggle = () => {
        if (onChange) {
            const newValue = !enabled;
            setEnabled(newValue);
            onChange(newValue);
        }
    };

    return (
        <div className="flex items-center py-2">
            <label className="relative inline-flex items-center cursor-pointer">
                <input
                    checked={enabled}
                    className="sr-only peer"
                    onChange={changeToggle}
                    type="checkbox"
                />
                <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-focus:ring-2 peer-focus:ring-gray-300 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-admin"></div>
                {label && (
                    <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                        {label}
                    </span>
                )}
            </label>
        </div>
    );
};
